import React from 'react';
import sanitize from 'utils/sanitize';
import { useAppDispatch, useAppSelector } from 'utils/hooks';

import ProductButton from 'components/shared/ProductButton';

import activeEditor from 'domains/active_editor';
import products from 'domains/products';
import canvases from 'domains/canvases';

const productButtonClickThrottle: { lastrun?: number; delay: number } = {
  lastrun: undefined,
  delay: 1000,
};

type ProductButtonContainerProps = {
  id: number;
  handleOpenTooltipModal: (id: number, triggerId: string) => void;
};

function ProductButtonContainer({
  id,
  handleOpenTooltipModal = () => {},
}: ProductButtonContainerProps) {
  const dispatch = useAppDispatch();
  const activeProductId = useAppSelector(activeEditor.selectors.productId);
  const product = useAppSelector((state) => products.selectors.selectById(state, id));

  if (!product) return null;

  const imageUrl = product.image_url;

  const isSelected = id === activeProductId;

  function openTooltipModal(clickedProductButtonId: string) {
    handleOpenTooltipModal(id, clickedProductButtonId);
  }

  function handleSelectProduct() {
    const now = new Date().getTime();
    if (
      activeProductId !== id &&
      (!productButtonClickThrottle.lastrun ||
        now - productButtonClickThrottle.lastrun >= productButtonClickThrottle.delay)
    ) {
      productButtonClickThrottle.lastrun = now;
      dispatch(canvases.actions.changeActiveCanvasConfig.product(id));
    }
  }

  return (
    <ProductButton
      id={id}
      title={sanitize(product.name)}
      price={product.price}
      imageUrl={imageUrl}
      isSelected={isSelected}
      hasTooltip={!!product.tooltip_title}
      onClickTooltip={openTooltipModal}
      onClick={handleSelectProduct}
    />
  );
}
export default ProductButtonContainer;
